import React, { useState, useRef, useEffect } from "react";

export type OptionTypes = {
  value: string;
  label: React.ReactNode;
  onClick?: () => void;
};

type OptionActionProps = {
  actionButton: React.ReactNode;
  options: OptionTypes[];
  showFromTop?: boolean;
};
const OptionAction = ({
  actionButton,
  options,
  showFromTop = false,
}: OptionActionProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside the dropdown
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="relative inline-block text-left">
      <div
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
        className={``}
      >
        {actionButton}
      </div>

      {isOpen && (
        <div
          className={`absolute z-50 md:w-[210px] w-[170px] rounded-lg bg-white shadow-lg border border-slate-200 overflow-hidden ${showFromTop ? "top-14 right-0" : "animate-slide-down bottom-0 right-[36px]"}`}
        >
          <div className="rounded-md">
            <ul
              className="p-[5px]"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              {options.map((option) => (
                <li key={option.value}>
                  <button
                    onClick={option.onClick}
                    className={`block py-4 px-3 ${option.value === "remove" ? "text-[#D92D20]" : "text-gray-600 hover:text-black"} xl:text-[16px] md:text-[14px] text-[13px] w-full text-left font-medium hover:bg-gray-100 active:bg-[#226cb6] rounded-[5px] transition-colors duration-200`}
                    role="menuitem"
                  >
                    {option.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default OptionAction;
